const { Component, Utils, DOMUtils } = window.Liftoff;

Component.register(
  "image",
  class Image extends Component {
    constructor(config) {
      super(config);

      Utils.assignWithDefaults(
        this,
        {
          image: null,
          size: null,
          hpos: null,
          vpos: null,
          width: "100%",
          height: "100%",
          style: null,
          animation: null,
          popDurationMS: 500,
          popIterations: 1,
          animateInMethod: null,
          animateInDurationMS: 500,
          animateInDelayMS: 0,
        },
        this.config
      );
      this.image = this.image || null;

      // NOTE(brian): Temporary correction for switchover from background-size to
      // object-fit.
      if (this.size === "100% 100%") {
        this.size = "fill";
      }
    }

    load() {
      return this.isEmpty() ? Promise.resolve() : Utils.loadImage(this.image);
    }

    isEmpty() {
      return !this.image;
    }

    layout(parentNode) {
      super.layout(parentNode);

      this.el = document.createElement("img");
      this.el.classList.add("image-component");
      this.render();
      this.parentNode.appendChild(this.el);

      if (this.animateInMethod) {
        this.el.classList.add(`animation-${this.animateInMethod}`);
        DOMUtils.forceReflow(this.el);
        this.el.style.transitionDuration = `${this.animateInDurationMS}ms`;
        this.el.style.transitionDelay = `${this.animateInDelayMS}ms`;
      }

      this.addEventListeners();
    }

    addEventListeners() {
      this.on("set image", ({ image }) => {
        if (image === "") return;

        this.image = image;
        this.render();
      });

      this.on("animateIn", () => {
        if (this.animateInMethod) {
          this.el.classList.add("animate-in");
          if (this.animation) {
            DOMUtils.addOneTimeListener(this.el, "transitionend", () =>
              this._startRepeatingAnimation()
            );
          }
        }
      });
    }

    resize() { return true; }

    start() {
      if (!this.animateInMethod && this.animation) {
        this._startRepeatingAnimation();
      }
    }

    stop() {
      if (this.animation) {
        this.el.classList.remove(this.animation);
      }
    }

    restart() {
      this.stop();
      DOMUtils.forceReflow(this.el);
      this.start();
    }

    render() {
      if (!this.image) return;

      Object.assign(
        this.el.style,
        {
          width: this.width,
          height: this.height,
          objectPosition: `${this.hpos} ${this.vpos}`,
          objectFit: this.size,
        },
        this.style
      );
      this.el.src = this.image;
    }

    _startRepeatingAnimation() {
      if (!this.animation) return;

      Object.assign(this.el.style, { animationDelay: "0" });
      if (["pop", "blur-and-spin", "colorize"].includes(this.animation)) {
        Object.assign(this.el.style, {
          animationDuration: `${this.popDurationMS}ms`,
          animationIterationCount: `${this.popIterations === Infinity ? "infinite" : this.popIterations}`,
        });
      }

      this.el.classList.add(this.animation);
    }
  }
);



// WEBPACK FOOTER //
// ./components/image/image.js